import toMap from '~/misc/toMap';

export default toMap([
  'FUELSURCHARGE_GET_PRICE'
]);



// WEBPACK FOOTER //
// ./src/pages/FuelSurchargePage/state/types.js